import { render, staticRenderFns } from "./BranchRoleSelectDialog.vue?vue&type=template&id=f81df336&"
import script from "./BranchRoleSelectDialog.vue?vue&type=script&lang=js&"
export * from "./BranchRoleSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81df336')) {
      api.createRecord('f81df336', component.options)
    } else {
      api.reload('f81df336', component.options)
    }
    module.hot.accept("./BranchRoleSelectDialog.vue?vue&type=template&id=f81df336&", function () {
      api.rerender('f81df336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Performance/tabPane/BranchRoleSelectDialog.vue"
export default component.exports